import React, { useRef } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Info } from 'lucide-react';
import './info-popover.css';

/**
 * An "i" icon whose explanation opens in the app's green popover on hover or
 * keyboard focus — the one the guided verification wizard uses for "Om
 * mallen". Use it next to a label for a paragraph of context (why an account
 * is routed the way it is, what a setting affects) instead of a line of grey
 * text under the control.
 *
 * `title` is optional: with it the popover gets the tinted header, without it
 * the body stands alone.
 */

let seq = 0;

export default function InfoPopover({ title, children, placement = 'right', ariaLabel = 'Mer information' }) {
    const idRef = useRef(null);
    if (idRef.current === null) {
        seq += 1;
        idRef.current = `ll-info-popover-${seq}`;
    }

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement={placement}
            overlay={(
                <Popover id={idRef.current} className="ll-info-popover">
                    {title && <Popover.Header as="h4">{title}</Popover.Header>}
                    <Popover.Body>{children}</Popover.Body>
                </Popover>
            )}
        >
            <button type="button" className="ll-info-popover__trigger" aria-label={ariaLabel}>
                <Info size={15} />
            </button>
        </OverlayTrigger>
    );
}
